import React from 'react';

import { useTriggerEmailMessageSendMutation } from '@dashboard/generated/wp/administrator';
import { EmailMessageStatus, FEmailMessageFragment } from '@dashboard/generated/wp/platform';
import { Button } from '@mui/material';

type Props = {
  emailMessage: FEmailMessageFragment;
};

export default function TriggerSendButton({ emailMessage }: Props) {
  const [trigger, { loading: disabled }] = useTriggerEmailMessageSendMutation();

  const status = emailMessage.status;
  switch (status) {
    case EmailMessageStatus.Deleted:
    case EmailMessageStatus.Paused:
    case EmailMessageStatus.Succeeded:
      return null;
  }

  const onClick = () => {
    trigger({ variables: { id: emailMessage.id } });
  };
  return (
    <Button variant="contained" disabled={disabled} onClick={onClick}>
      Send
    </Button>
  );
}
